<template>
  <div :style="`backgroundColor:${ui.bg_color};width: 100%;`" class="main_first_wrapper"
       :class="custom_wrap">
    <!--  剩余门票-->
    <div class="notice_remain_continer">
      <remainTicket  :type="2"></remainTicket>

      <!--          <div class="remain_ticket_continer" :class="'remain_ticket_continer_' + ticket_type">-->
      <!--            <span class="left_tip size_34">今日免费门票剩余</span>-->
      <!--            <div class="remain_continer">-->
      <!--              <span v-for="(item,index) in remain_ticket" class="remain_txt">{{item}}</span>-->
      <!--            </div>-->
      <!--            <span class="left_tip size_34">张</span>-->
      <!--          </div>-->
    </div>
    <!--            高度不定 姓名手机号车型必填，单一城市，城市项不需要选择，-->
    <div class="main_form main_form_first" 
        :class="custom_form">
      <p class="lable_p" v-if="is_name" >您的姓名</p>
      <van-field
          v-if="is_name"
          v-model="action_form.name"
          name="姓名"
          placeholder="请输入您的姓名"
          class="custom_field"
      />

      <p class="lable_p">您的手机号码(已加密)</p>
      <van-field
          type="tel"
          v-model="action_form.phone"
          name="电话"
          placeholder="请输入您的手机号码"
          class="custom_field"
      />

      <template v-if="is_show_car">
         <p class="lable_p">选择您的意向车型</p>
        <van-field
            v-model="action_form.car_name"
            readonly
            placeholder="意向车型（品牌+厂商+车型）"
            @click="openCarDialog"
            class="custom_field"
            :class="is_city==false ? 'mb_15' : ''"
        >
          <template slot="right-icon">
            <van-icon name="play" style="transform: rotate(90deg)" color="#a0a4ac"/>
          </template>
        </van-field>
      </template>
      <!--          v-if="is_city"-->
      <p class="lable_p" v-if="is_city">您所在的城市</p>
      <van-field
          v-if="is_city"
          v-model="action_form.city"
          readonly
          placeholder="选择您所在的城市"
          @click="openCityDialog"
          class="custom_field mb_15"
          style="margin-bottom: 4px;"
      >
        <template slot="right-icon">
          <van-icon name="play" style="transform: rotate(90deg)" color="#a0a4ac"/>
        </template>
      </van-field>

      <!--  按钮-->
      <div class="main_form_btn">


        <!-- 报名人数-->
        <registNumber :type="2"></registNumber>

        <div class="form_btn" @click="submitForm" :style="`backgroundColor: ${ui.btn_bg_color};`">
          <span  :style="`color: ${is_opacity}`">{{ui.btn_text}}</span>
          <img src="../../assets/image/new_img/pointer_01.png" alt="" class="form_pointer finger_1" style="z-index: 30;">
          <div class="flash_circle" style="z-index: 10;"></div>
        </div>
      </div>
      <!-- 协议-->
      <div class="form_policy">
        <policy :custom_col="'#323232'"></policy>
      </div>
    </div>
  </div>
</template>

<script>
  import remainTicket from "@/components/remainTicket";
  import registNumber from "@/components/registNumber";
  import policy from "@/components/policy";
  export default {
    name: "FormOne",
    components: {
      remainTicket,
      registNumber,
      policy,
    },
    data() {
      return {
        // is_name:true //是否显示姓名
      };
    },
    props: {
      ui: {
        type: Object,
        default: () => ({}),
      },
      stime: {
        type: Number,
        default: 0,
      },
      action_form: {
        type: Object,
        default: () => ({}),
      },
      is_dialog_car: {
        type: Boolean,
        default: false,
      },
      is_city: {
        type: Boolean,
        default: false,
      },
      city_show: {
        type: Boolean,
        default: false,
      },
      is_stop: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: "",
      },
      remain_ticket: {
        type: Array,
        default: () => [],
      },
      number_1: {
        type: Number,
        default: 0,
      },
      number_2: {
        type: Number,
        default: 0,
      },
      is_opacity: {
        type: String,
        default: '#fff',
      },
      is_show_car: {
        type: Boolean,
        default: true,
      },
      tid:{
          type: Number,
          default: 0
        },
      title:{
        type: String,
        default: ''
      },
       is_name: {
        type: Boolean,
        default: true,
      },
      custom_wrap: {
        type: String,
        default: '',
      },
      custom_form: {
        type: String,
        default: '',
      },
    },
    methods: {
      submitForm() {
        this.$emit("submitForm");
      },
      openCarDialog() {
        this.$emit("openCarDialog");
      },
      openCityDialog() {
        this.$emit("openCityDialog");
      },
    },

   
     watch: {
      // title(v) {
      //   this.is_name = !(this.title.indexOf('家博会')>-1 && this.tid == 5)
      //   console.log(this.is_name);
      // },
    }
  }
</script>


<style lang="less" scoped>
  @import "../../assets/style/autoshow/base.less";
  @import "../../assets/style/autoshow/base_form.less";
  @import "../../assets/style/form_h.less";

 
</style>

